import React from 'react';
import { OFFICER_ROLE_NAMES } from '../../../../utils/constants';
import StaffTableRow from '../StaffTableRow/StaffTableRow';
import './StaffTable.css';

// One shared page across all role groups, 5 members per role per page - a
// role with no members left on this page is left out entirely instead of
// showing an empty section.
export const MEMBERS_PER_PAGE = 5;

const StaffTable = ({ groupedOfficers, stageColumns, currentPage, handlePageChange, branchApplicationFilters, setBranchApplicationFilters }) => {
    let colSpanCount = stageColumns.length + 4;

    return (
        <table className="staff-overview-table">
            <thead>
                <tr>
                    <th>Staff Member</th>
                    <th>Role</th>
                    <th>Branch</th>
                    <th>Total Files</th>
                    {stageColumns?.map((stage) => {
                        return (
                            <th key={stage.key}>{stage?.label}</th>
                        )
                    })}
                </tr>
            </thead>
            <tbody>
                {groupedOfficers?.map((group) => {
                    const startIdx = (currentPage - 1) * MEMBERS_PER_PAGE;
                    const pagedOfficers = group.officers.slice(startIdx, startIdx + MEMBERS_PER_PAGE);

                    // A role with members elsewhere, but none on this page, is
                    // skipped entirely rather than shown as an empty section.
                    // A role with no members at all still gets its "no data"
                    // placeholder, but only on the first page.
                    if (pagedOfficers.length === 0 && (group.officers.length > 0 || currentPage > 1)) {
                        return null;
                    }

                    return (
                        <React.Fragment key={group.role}>
                            <tr className="role-group-header">
                                <td colSpan={colSpanCount}>{OFFICER_ROLE_NAMES?.[group.role]} ({group.role})</td>
                            </tr>

                            {
                                group.officers.length === 0 ? (
                                    <tr className={`${group.role}`}>
                                        <td colSpan={colSpanCount} className="no-data-cell-short">
                                            No team member's data found under this role
                                        </td>
                                    </tr>
                                ) : (
                                    pagedOfficers.map((officer) => (
                                        <tr
                                            key={officer?.officer_id}
                                        // className={`${group.role}`}
                                        >
                                            <StaffTableRow
                                                // key={officer?.officer_id}
                                                officer={officer}
                                                stageColumns={stageColumns}
                                                handlePageChange={handlePageChange}
                                                branchApplicationFilters={branchApplicationFilters}
                                                setBranchApplicationFilters={setBranchApplicationFilters}
                                            />
                                        </tr>
                                    ))
                                )
                            }
                        </React.Fragment>
                    );
                })}
            </tbody>
        </table>
    );
};

export default StaffTable;
